export const RESET = 'PACKAGES_LIST/RESET';
export const REQUEST = 'PACKAGES_LIST/REQUEST';
export const RECEIVE = 'PACKAGES_LIST/RECEIVE';
export const REQUEST_ERROR = 'PACKAGES_LIST/REQUEST_ERROR';

export const CHANGE_STATUS_FILTER = 'PACKAGES_LIST/CHANGE_STATUS_FILTER';
export const CHANGE_VERSIONS_FILTER = 'PACKAGES_LIST/CHANGE_VERSIONS_FILTER';
export const CHANGE_HARDWARE_LIST_FILTER =
  'PACKAGES_LIST/CHANGE_HARDWARE_LIST_FILTER';
